// removed by extract-text-webpack-plugin
module.exports = {"content":"components-chooseBed-index-content-qx81E","floor":"components-chooseBed-index-floor-pCw7y","active":"components-chooseBed-index-active-3j-Fz","room":"components-chooseBed-index-room-2FdXk","title_normal":"components-chooseBed-index-title_normal-1g-K9","title_choosen":"components-chooseBed-index-title_choosen-2usVy","card_disabled":"components-chooseBed-index-card_disabled-3TMTf","room_box":"components-chooseBed-index-room_box-1MUYD","bed_list":"components-chooseBed-index-bed_list-16qq3","choosen":"components-chooseBed-index-choosen-1qlJ8","cur_selected":"components-chooseBed-index-cur_selected-32tJP"};


//////////////////
// WEBPACK FOOTER
// ./components/chooseBed/index.css
// module id = 2270
// module chunks = 0